module.exports = __webpack_public_path__ + "img/OMBRA.f287be3d.png";